export const statuses = [
  'Draft',
  'Draft Out',
  'Redraft',
  'ReDraft Out',
  'Out for Signature',
  'Partially Executed',
  'Fully Executed',
];
